<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 col-md-6">
      <div class="text-h6 q-mb-md">
        {{ $t('components.doctorCreditsTab.sections.creditsHistory') }}
      </div>

      <doctor-credits-history
        ref="doctor-credits-history"
        :doctor-id="+$route.params.doctorId"
        class="col-12 col-md-6"
      />
    </div>
  </div>

  <topup-modal
    ref="topup-modal"
    :doctor-id="+$route.params.doctorId"
    :doctor-balance="doctor.balance"
    @topup="onTopup"
  />
</template>

<script>
import DoctorCreditsHistory from '@/components/DoctorCreditsHistory.vue';
import TopupModal from '@/components/TopupModal.vue';

export default {
  components: {
    DoctorCreditsHistory,
    TopupModal,
  },
  props: {
    doctor: {
      type: Object,
      requried: true,
    },
  },
  created() {
    this.updateTitle();
    this.updateButtons();
  },
  methods: {
    updateTitle() {
      this.$emit(
        'update:title',
        this.$t('components.doctorCreditsTab.credits', {
          credits: this.$numeral(this.doctor.balance).format('0,0'),
        })
      );
    },
    updateButtons() {
      this.$emit('update:buttons', [
        {
          isAllowed: this.$isAllowed('dealer/transactions/create'),
          color: 'primary',
          label: this.$t('components.doctorCreditsTab.topDownButtonTitle'),
          isOutline: true,
          onClick: this.openModalToWithdrawCredits,
        },
        {
          isAllowed: this.$isAllowed('dealer/transactions/create'),
          color: 'primary',
          label: this.$t('components.doctorCreditsTab.topUpButtonTitle'),
          isOutline: true,
          onClick: this.openModalToSendCredits,
        },
      ]);
    },
    openModalToWithdrawCredits() {
      this.$refs['topup-modal'].open('topDown');
    },
    openModalToSendCredits() {
      this.$refs['topup-modal'].open('topUp');
    },
    async onTopup(transaction) {
      await this.$emit('update:doctor', {
        ...this.doctor,
        balance: this.doctor.balance + transaction.credits,
      });
      this.updateTitle();

      this.$refs['doctor-credits-history'].addRow(transaction);
      this.$refs['doctor-balance-chart'].getData();
    },
  },
};
</script>
